const MAccountant = [
  {
    title: 'Dashboard',
    is_heading: false,
    is_active: false,
    link: {
      name: 'accountant.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-objects-column',
    active_icon: 'fad fa-objects-column'
  },
  {
    title: 'Tracking',
    is_heading: true,
    is_active: false,
    link: {
      name: 'accountant.tracking'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  {
    title: 'Signed Memos',
    is_heading: false,
    is_active: false,
    link: {
      name: 'accountant.tracking.customer-memos'
    },
    class_name: '',
    collapsable: false,
    is_icon_class: true,
    icon: 'fat fa-handshake',
    active_icon: 'fad fa-handshake'
  }
]

export default MAccountant
